//PAGE URL
// export const pageUrl = 'http://localhost:3000';
// export const pageUrl = 'https://generator-operon.soppo.pl/'
export const pageUrl = 'https://generator.operon.pl'
// export const pageUrl = 'https://acc-generator.operon.pl'
// export const pageUrl = 'https://dev-generator.operon.pl'

//OPERON ID
export const operonIdUrl = 'https://id.operon.pl/simplesaml/module.php/oauth2/';
export const clientId = '_41096e29e5ffc37f0a736388a9d34f16e8d51c2faf';
export const secretId = '_56d26fcb039e63f7cefd8d10e95ef2c56201b1859c';

// export const redirectUrl = 'http://localhost:3000/login';
// export const redirectUrl = 'https://generator-operon.soppo.pl/login'
export const redirectUrl = 'https://generator.operon.pl/login'
// export const redirectUrl = 'https://acc-generator.operon.pl/login'
// export const redirectUrl = 'https://dev-generator.operon.pl/login'

//API URL
export const apiUrl = 'https://api2-generator.operon.pl'
// export const apiUrl = 'http://api-generator.operon.pl/acc'
// export const apiUrl = 'http://api-generator.operon.pl/dev';

export const apiEndpoint = `${apiUrl}/Service.php`;

// TASKS URL

export const tasksHost = `${apiUrl}/KPVN89UkWAuBMxdX4XVs2Gvx`;
